import React from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import { ISubCategoryPositionItemV2 } from 'types';
import Text from 'components/Text/Text';
import { ImgUploaderByPreSignedUrl } from 'components/ImgUploader/ImgUploaderByPreSignedUrl';
import { Badge } from 'components/Badge';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IProps {
	data: ISubCategoryPositionItemV2;
	positionNumber: number;
	dragHandleProps?: DraggableProvidedDragHandleProps;
}

export const Item: React.FC<IProps> = ({ data, positionNumber, dragHandleProps }) => {
	const containerClasses = classNames(style.container);
	const subCategoryRowClasses = classNames(style.subCategory, style.row);
	const imgWrapperClass = classNames(style.imgWrapper);
	const subCategoryNameClasses = classNames(style.subCategoryName);
	const hiddenStatusRowClasses = classNames(style.hiddenStatus, style.row);
	const availableForRepetitionRowClasses = classNames(style.availableForRepetition, style.row);

	return (
		<div className={containerClasses}>
			<div className={subCategoryRowClasses}>
				<div className={style.positionNumber}>{positionNumber}</div>
				<div className={style.dragMark} {...dragHandleProps}>
					<svg>
						<use xlinkHref={`${breadcrumbs}#dragMark`} />
					</svg>
				</div>
				<div className={imgWrapperClass}>
					<ImgUploaderByPreSignedUrl loaderSize="small" preSignedUrl={data.preSignedUrl} />
				</div>
				<Text className={subCategoryNameClasses} translationKey={data.name} withTooltip={true} />
			</div>
			<div className={hiddenStatusRowClasses}>
				<Badge color={data.isHidden ? 'red' : 'purple'}>
					<Text
						translationNameSpace="listing"
						translationKey={data.isHidden ? 'isHiddenFemaleLabel' : 'visibleFemaleLabel'}
						asFragment={true}
						data-test="isHidden"
					/>
				</Badge>
			</div>
			<div className={availableForRepetitionRowClasses}>
				<Badge color={data.availableForRepetition ? 'purple' : 'red'}>
					<Text
						translationNameSpace="listing"
						translationKey={data.availableForRepetition ? 'availableLabel' : 'unavailableLabel'}
						asFragment={true}
						data-test="availableForRepetition"
					/>
				</Badge>
			</div>
		</div>
	);
};
